export default __webpack_public_path__ + "static/char-s-43-ja-052883a35f2207057e2121edfb5e62eb.png";